import { Button } from '@cokitchen/cokitchen-components';
import { EditAltIcon } from 'cokitchen-icons';
import { MealItemType } from 'models/production-report.model';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
type Props = {
  selectedMeals: MealItemType[];
  setSelectedMeals: (meals: MealItemType[]) => void;
};
const BulkAction = ({ selectedMeals, setSelectedMeals }: Props) => {
  const navigate = useNavigate();
  return (
    <div className='fixed bottom-2 sm:bottom-8 left-4 sm:left-[10%] md:left-[18%] lg:left-[35%] bg-white rounded-[40px] w-full max-w-[477px] h-[65px] px-5 py-[18px] flex items-center justify-between bulk_action'>
      <p className='text-sm text-gray-9'>{selectedMeals.length} items selected</p>
      <div
        className='py-[6px] px-[10px] flex rounded-lg gap-1 bg-[#F2F2F2] text-gray-9 cursor-pointer'
        onClick={() => navigate(MAIN_STORE_ROUTE_KEYS.KITCHEN_EDIT_COKITCHEN_ITEM)}>
        <EditAltIcon />
        <p className='text-[#585F68] text-xs'>Edit kitchen items</p>
      </div>
      <Button
        variant='block'
        color='primary'
        className='w-[79px] h-[29px] !py-[6px] text-xs rounded-lg'
        onClick={() => setSelectedMeals([])}>
        Done
      </Button>
    </div>
  );
};

export default BulkAction;
